import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'category/:id',
        name: 'Category',
        component: () => import('@/views/Category.vue'),
        meta: { title: '分类' }
      },
      {
        path: 'search',
        name: 'Search',
        component: () => import('@/views/Search.vue'),
        meta: { title: '搜索' }
      },
      {
        path: 'article/:id',
        name: 'Article',
        component: () => import('@/views/ArticleDetail.vue'),
        meta: { title: '文章详情' }
      },
      {
        path: 'user',
        component: () => import('@/layouts/UserLayout.vue'),
        meta: { auth: true },
        children: [
          {
            path: 'favorite',
            name: 'Favorite',
            component: () => import('@/views/user/Favorite.vue'),
            meta: { title: '我的收藏', auth: true }
          },
          {
            path: 'history',
            name: 'History',
            component: () => import('@/views/user/History.vue'),
            meta: { title: '浏览记录', auth: true }
          }
        ]
      }
    ]
  },
  {
    path: '/user/login',
    name: 'Login',
    component: () => import('@/views/user/Login.vue'),
    meta: { title: '登录', guest: true }
  },
  {
    path: '/user/register',
    name: 'Register',
    component: () => import('@/views/user/Register.vue'),
    meta: { title: '注册', guest: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { title: '页面不存在' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  const userStore = useUserStore()
  if (!userStore.token && !userStore.profile) {
    userStore.hydrate()
  }

  document.title = to.meta.title ? `${to.meta.title} · 文萃` : '文萃'

  if (to.meta.auth && !userStore.isLogin) {
    return {
      name: 'Login',
      query: { redirect: to.fullPath }
    }
  }

  if (to.meta.guest && userStore.isLogin) {
    return { name: 'Home' }
  }

  return true
})

export default router
